import { useMutation } from "@tanstack/react-query";
import api from "../../../api";
import { toast } from "react-toastify";
import { toastStyles } from "../../../styles/styles";
import { PAGE_CONFIG } from "../config";

export const useDeleteUpload = (queryClient, theme, onSuccessCallback) => {

    const { mutate: deleteUpload, status: deleteStatus, isPending: isDeleting } = useMutation({
        mutationFn: (id) => api.upload.deleteUpload(id),
        onSuccess: (data) => {
            toast.success(data?.message || 'Upload deleted successfully', { ...toastStyles, theme: theme });
            queryClient.invalidateQueries([PAGE_CONFIG.GET_QUERY_KEY]);
            onSuccessCallback && onSuccessCallback();
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || 'Upload deletion failed', { ...toastStyles, theme: theme });
        }
    });

    return { deleteUpload, isDeleting, deleteStatus };
}